import { Col, Datepicker, InputField, Label, OutlineButton, SwitchToggle, Tooltip } from "client/CommonComponents"
import './AdminTask.scss'
import CancelConfirmationPopup from "client/CommonComponents/DialogBox/CancelConfirmationPopup";
import CompletedIcon from '../../../../assets/images/Completed.svg'
import UpNextIcon from '../../../../assets/images/Up Next.svg'
import NotStartedIcon from '../../../../assets/images/Not Started.svg'
import NA from '../../../../assets/images/NA.svg'
import DelayedIcon from '../../../../assets/images/Delayed.svg'
import pendingIcon from '../../../../assets/images/Pending.svg'
import { CONSTANTS } from "client/utils/constants";
import TaskReset from '../../../../assets/images/TaskReset.svg'
import { isAuthorized } from "client/utils/Permissions";
import { FLEET_PROCESSING_PERMISSIONS } from "client/utils/constants/fleetProcessingPermissions";

const AdminTask = (props: any) => {
    const { isComplete } = props
    const itemType = props?.itemType
    const groupedItemDetail = props?.groupedItemDetail;
    const handleChangeToggle = props?.handleChangeToggle;
    const handleBlurComment = props?.handleBlurComment;
    const onChangeComment = props?.onChangeComment;
    const handleClickComment = props?.handleClickComment;
    const handleDateChange = props?.handleDateChange;
    const Popupcontent = props?.Popupcontent
    const hideDialog = props?.hideDialog;
    const purchaseOrderStepperData = props?.purchaseOrderStepperData
    const isDisableOncomplete = props?.isDisableOncomplete
    const handleClickReset = props?.handleClickReset

    const iconReturn = (status: any) => {
        let src = "";
        switch (status) {
            case "Completed":
                src = CompletedIcon;
                break;
            case "Up Next":
                src = UpNextIcon;
                break;
            case "Delayed":
                src = DelayedIcon;
                break;
            case "Not Started":
                src = NotStartedIcon;
                break;
            case "N/A":
                src = NA;
                break;
            case "Pending":
                src = pendingIcon;
                break;
            default:
                break;
        }
        return <><img src={src} alt="Error Image" className={`${status == 'N/A' ? 'na-error-image' : 'error-image'}`} /><span>{status}</span></>;
    }

    const isTaskEditable = (taskDescription: string) => {
        const isInvoiceTask = taskDescription?.toLowerCase() === CONSTANTS?.FLEET_PROCESSING_TASKS?.INVOICE_VOUCHERED || taskDescription?.toLowerCase() === CONSTANTS?.FLEET_PROCESSING_TASKS?.INVOICE_PAID;
        return isInvoiceTask && !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.EDIT_FLEET_ADMIN_INVOICE_TASKS) && !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.EDIT_FLEET_ADMIN_TASKS) && !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.UPDATE_FLEET_ADMIN_TASKS);
    }

    return (<>
        <Col xs={12} md={12} lg={12} className="p-3">
            <div className="admin-sttepper-content">
                <div className="header-block">
                    <p className="step">Step</p>
                    <p className="task">Task</p>
                    <p className="completeddate">Completed Date</p>
                    <p className="comments">Comments</p>
                    <p className="completedby">Completed By</p>
                    <p className="status">Status</p>
                    <p className="Na_block">N/A</p>
                </div>
                <div className="content-block">
                    {
                        groupedItemDetail?.map((groupItem: any, index: any) => {
                            return (
                                <div className="content-with-warning" key={index}>
                                    <div className="content-card" key={index}>
                                        <p className="step">{groupItem.Step}</p>
                                        <div className="content-card nested-right-block" key={index}>
                                            {
                                                groupItem?.Details?.map((itemValue: any, index: any) => {
                                                    return (<div className={`rowspan-block ${itemValue.taskStatus}`} key={index}>
                                                        <p className="task">{itemValue?.taskDescription}</p>
                                                        <p className="completeddate">
                                                            <Datepicker
                                                                placeholder="MM/DD/YYYY"
                                                                allowTextInput={true}
                                                                disabled={itemValue?.isDisabled || itemValue?.isApplicable || isDisableOncomplete() || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.EDIT_FLEET_ADMIN_TASKS) || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.UPDATE_FLEET_ADMIN_TASKS) || isTaskEditable(itemValue?.taskDescription)}
                                                                value={!itemValue?.isApplicable ? itemValue?.completedOn : null}
                                                                onChangeDate={(date: any) => handleDateChange(date, itemValue?.poFleetRequestTaskListTrackingId, groupItem.Step)}
                                                                maxDate={(itemValue?.taskDescription?.toLowerCase() === CONSTANTS?.FLEET_PROCESSING_TASKS?.ESTIMATED_DELIVERY_DATE || itemValue?.taskDescription?.toLowerCase() === CONSTANTS?.FLEET_PROCESSING_TASKS.INVOICE_VOUCHERED) ? '' : new Date()}
                                                             data-attribute="AdminTask_Default_Datepicker" />
                                                            {!isDisableOncomplete() || purchaseOrderStepperData?.itemStatus !== CONSTANTS.ORDER_STATUS.CANCELLED && isAuthorized(FLEET_PROCESSING_PERMISSIONS?.EDIT_FLEET_ADMIN_TASKS) && isAuthorized(FLEET_PROCESSING_PERMISSIONS?.UPDATE_FLEET_ADMIN_TASKS) ?
                                                                <Tooltip content={"Reset"} data-attribute="AdminTask_Default_Tooltip">
                                                                    <input type="image" src= {TaskReset} 
                                                                        className="ms-2 mt-0 mb-1 completed-reset"
                                                                        onClick={() => handleClickReset(itemValue?.isApplicable, itemValue?.completedOn, itemValue?.comment, itemValue?.poFleetRequestTaskListTrackingId, groupItem.Step)}
                                                                        disabled={isTaskEditable(itemValue?.taskDescription)}
                                                                     data-attribute="AdminTask_Default_Input" />
                                                                </Tooltip>
                                                            : null}
                                                        </p>
                                                        <p className="comments" onClick={(e: any) => handleClickComment(e, itemValue?.poFleetRequestTaskListTrackingId, groupItem.Step)}>
                                                            {(!itemValue?.isShowTextBox && itemValue?.comment?.length && !itemValue?.isCommentEdited) ? <Tooltip content={itemValue.comment} data-attribute="AdminTask_Default_Tooltip_2">{itemValue.comment}</Tooltip> :
                                                                <Tooltip content={itemValue.comment} data-attribute="AdminTask_Default_Tooltip_3"><InputField
                                                                    value={itemValue?.comment}
                                                                    className={itemValue?.commentError ? 'controlValidation' : ''}
                                                                    onChange={(item?: any) => { onChangeComment(item, itemValue?.poFleetRequestTaskListTrackingId, groupItem.Step) }}
                                                                    onBlur={(e: any) => handleBlurComment(e, itemValue?.poFleetRequestTaskListTrackingId, groupItem.Step)}
                                                                    disabled={isDisableOncomplete() || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.EDIT_FLEET_ADMIN_TASKS) || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.UPDATE_FLEET_ADMIN_TASKS) || isTaskEditable(itemValue?.taskDescription)}
                                                                 data-attribute="AdminTask_Default_Input_2" /></Tooltip>}
                                                            <span className="validMessage">{itemValue?.commentError}</span>
                                                        </p>
                                                        <p className="completedby">
                                                            <Tooltip content={itemValue.completedBy} data-attribute="AdminTask_Default_Tooltip_4">{itemValue.completedBy}</Tooltip>
                                                        </p>
                                                        <p className="status">{iconReturn(itemValue.taskStatus)}</p>
                                                        <p className="Na_block">
                                                            <SwitchToggle
                                                                className="mt-2"
                                                                checked={itemValue?.isApplicable}
                                                                onChange={(e: any, item: any) => { handleChangeToggle(e, item, itemValue?.poFleetRequestTaskListTrackingId, groupItem.Step) }}
                                                                disabled={ isDisableOncomplete() || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.EDIT_FLEET_ADMIN_TASKS) || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.UPDATE_FLEET_ADMIN_TASKS) || isTaskEditable(itemValue?.taskDescription) }
                                                             data-attribute="AdminTask_Default_SwitchToggle" />
                                                        </p>
                                                    </div>)
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </Col>
        {itemType === CONSTANTS.REQUISITION ? 
        <>
        <div className="cancel-btn-block-task">
            <OutlineButton
                text="Cancel"
                className={`cancel-btn me-2 ${isComplete ? "cancel-btn-with-right-space": ""}`}
                onClick={props?.handleClickCancel}
             data-attribute="AdminTask_Default_Button" />          
        </div>
        </> : null }
        <>
        {
                Popupcontent.isDialogVisible && (
                    <CancelConfirmationPopup
                        hideDialog={!Popupcontent.isDialogVisible}
                        onDismiss={Popupcontent?.popupOutlinebtnOnclick ? Popupcontent?.popupOutlinebtnOnclick : hideDialog}
                        Popupcontent={Popupcontent}
                        popupOutlinebtnOnclick={() => Popupcontent?.popupOutlinebtnOnclick()}
                        popupPrimarybtnOnclick={() => Popupcontent?.popupPrimarybtnOnclick()}

                    />
                )
            }</>
    </>)
}

export default AdminTask